export default function uniqueRiskTypeNameDirective(
  $q,
  riskDataService
) {
  // console.log('app.components.advisory.enterpriseModeling.departmentUniqueNameValidator created');
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ngModel) => {
      const customerRiskTypeId = attributes.customerRiskTypeId || 0;
      ngModel.$asyncValidators.riskTypeUniqueName = (modelValue) => {
        const defer = $q.defer();
        riskDataService.checkRiskTypeExists(customerRiskTypeId, modelValue).then((data) => {
          if (data && data.data.result === false) {
            defer.resolve();
          } else {
            defer.reject();
          }
        }).catch(defer.reject);
        return defer.promise;
      };
    },
  };
}

export const name = 'riskTypeUniqueName';

uniqueRiskTypeNameDirective.$inject = [
  '$q',
  'riskDataService',
];
